export const sizes = {
    max991: `(max-width: 991px)`,
}
